export default {
  GET_STATE(state, details) {
    if (!details || !details.data || !details.data[0]) {
      return
    }
    
    const user = details.data[0]
    
    localStorage.setItem('user_name', user.full_name || '')
    localStorage.setItem('lkjhgfdsa', user.public_id || '')
    localStorage.setItem('user_public_id', user.public_id || '')
    
    if (user.email) {
      localStorage.setItem('user_email', user.email)
    }
    
    if (user.user_type_id) {
      try {
        const unem = JSON.parse(localStorage.getItem('unem') || '{}')
        unem.user_type_id = user.user_type_id
        localStorage.setItem('unem', JSON.stringify(unem))
      } catch (e) {
      }
    }
    
    state.session = user
  }
}